import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { VendorStatusInformation } from '../models/vendor-status-information.model';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-vendor-status-list',
  templateUrl: './vendor-status-list.component.html',
  styleUrls: []
})
export class VendorStatusListComponent implements OnInit {

  @ViewChild('listForm') listForm: NgForm;
  @Input() vendorId: string;
  theList: VendorStatusInformation[] = [];
  submitAttempt: boolean = false;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.ajax.MakeCall<VendorStatusInformation[]>('/Vendor/StatusList', { vendorId: this.vendorId }).then((data) => {
      this.theList = data;
    }, () => { this.dismiss(); });
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  add(): void {
    this.theList.push(new VendorStatusInformation());
    this.listForm.form.markAsDirty();
  }

  remove(i: number): void {
    this.theList.splice(i, 1);
    this.listForm.form.markAsDirty();
  }

  save(): void {
    this.submitAttempt = true;
    if (this.listForm.invalid) {
      return;
    }

    this.ajax.MakeCall<boolean>('/Vendor/SaveStatusList', { info: this.theList, vendorId: this.vendorId }).then((data) => {
      this.modal.close();
    }, () => { });
  }
}
